import React, { useRef } from 'react';
import bem from 'utils/bem';
import DesktopMenu from 'components/Menu';
import LoginButton from 'components/LoginButton';
import Logo from 'components/Logo';
import CartWidget from 'components/CartWidget';
import SocialIcons from 'components/SocialIcon/SocialIcons';
import useSticky from '../useSticky';

import './index.sass';

const { block, cnEl, el } = bem('fixed-header');

const FixedHeader = ({ menu }) => {
    const ref = useRef(null);
    const { sticky, animated } = useSticky(ref);

    return (
        <div className={block()} ref={ref}>
            <div className={cnEl('mui-fixed', 'box', {'animated': animated, 'sticky': sticky})}>
                <div className={ el('content', {'fixed': true}) }>
                    <div className={ el('logo', { animated, sticky }) }>
                        <Logo />
                    </div>
                    <div className={ el('menu') }>
                        <DesktopMenu
                            data={ menu }
                            mods={ { animated, sticky, black: true } }/>
                    </div>
                    <div className={ el('socials') }>
                        <SocialIcons />
                    </div>
                    <div className={el('cart')}>
                        <CartWidget />
                    </div>
                    <div className={el('login')}>
                        <LoginButton />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FixedHeader;
